import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import Hidden from '@material-ui/core/Hidden';

import List from './List';
import Menu from '../Menu';
import Error from '../../../dialogs/Error';

import * as actions from '../../../../actions/locals.actions';
import * as home from '../../../../actions/process.home.actions';
import * as inventory from '../../../../actions/process.inventory.actions';

class Locals extends React.Component {

    state = {
        locals: undefined
    };

    constructor(props) {
        super(props);
        props.allLocalInfo();
    }

    componentDidMount() {
        this.props.setSearch(true);
        this.props.setInventoryWindow("locals");
    }

    componentWillUnmount() {
        this.props.setSearch(false);
    }

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    }

    render() {
        const { info } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '81') &&
              info.security.licencias.some((f) => f.id === 157 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    <Hidden xsDown>
                        <div className={'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white showbar'}>
                            <Menu code={4} />
                        </div>
                    </Hidden>
                    <div className={'flex_full'}>
                        <div className={'flex_full overflow_y_scroll center height100 bg_ice_blue showbar'}>
                            <List {...this.props} />
                        </div>
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        locals: state.localsInfo,
        locals_has_errored: state.locals_has_errored,
        locals_is_loading: state.locals_is_loading,
        window_searchs: state.window_searchs,
        info: state.info
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home, inventory), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Locals));



// WEBPACK FOOTER //
// ./src/components/complex/manage/locals/Index.js